import React from 'react'
import { Checkbox } from '.'

const VisibilityCheckboxes = ({name, ...props}) => {
  return (
    <div>
      <div className="flex flex-wrap -mx-2 lg:mx-0">
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Checkbox
            className="mb-4 lg:mb-2"
            id={`${name}_checkbox1`}
            label="Public"
            name={name}
            value="public"
            defaultChecked={true}
          />
        </div>
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Checkbox
            className="mb-4 lg:mb-2"
            id={`${name}_checkbox2`}
            label="Verified User"
            name={name}
            value="verified_user"
          />
        </div>
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Checkbox
            className="mb-4 lg:mb-2"
            id={`${name}_checkbox3`}
            label="Organization"
            name={name}
            value="organization"
          />
        </div>
        <div className="w-1/2 lg:w-auto lg:mr-16 px-2 lg:px-0">
          <Checkbox
            className="mb-4 lg:mb-2"
            id={`${name}_checkbox4`}
            label="My Organization"
            name={name}
            value="my_organization"
          />
        </div>
      </div>
    </div>
  )
}

export { VisibilityCheckboxes }